import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { map } from 'rxjs/operators';

import { UserMenuRouterService } from '../service/user-menu-router.service';

@Component({
  selector: 'epc-menu-route-wrapper',
  templateUrl: './menu-route-wrapper.component.html',
  styleUrls: ['./menu-route-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MenuRouteWrapperComponent {
  @Output()
  public closeClick = new EventEmitter<void>();

  public activeRoute$ = this.menuRouterService.routerState$;

  public header$ = this.activeRoute$.pipe(
    map((routerState) => {
      switch (routerState) {
        case 'BusinessContacts':
          return $localize`:UserMenu@@userMenuBusinessContactsTitle:Business Contacts`;
        case 'ChangePassword':
          return $localize`:UserMenu@@changePasswordTitle:Change password`;
        case 'UserAccounts':
          return $localize`:UserMenu@@userAccountsTitle:Accounts`;
        case 'UserContacts':
          return $localize`:UserMenu@@UserContactsTitle:Contacts`;
        case 'AssortmentManager':
          return $localize`:UserMenu@@AssortmentManagerTitle:Assortments`;
        case 'MainUserMenu':
        default:
          return $localize`:UserMenu@@userMenuTitle:My profile`;
      }
    }),
  );

  constructor(private menuRouterService: UserMenuRouterService) {}

  public back() {
    this.menuRouterService.go('MainUserMenu');
  }

  public handleClose() {
    this.back();
    this.closeClick.emit();
  }
}
